"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPhotoUploadRequest = void 0;
var file_1 = require("../../../library/file");
var UserPhotoUploadRequest = /** @class */ (function () {
    function UserPhotoUploadRequest() {
        this.file = new file_1.File();
        this.imageType = '';
    }
    return UserPhotoUploadRequest;
}());
exports.UserPhotoUploadRequest = UserPhotoUploadRequest;
;
//# sourceMappingURL=userPhotoUpload.request.js.map